import React, { useState, useRef, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

function Heading({ onMoveUp, onMoveDown, onElementDelete, preset }) {
  // States
  const [element, setElement] = useState({
    type: "heading",
    properties: {
      title: "Group Heading",
    },
  });
  const [modal, setModal] = useState(false);

  // Refs
  const elementTitleRef = useRef();

  // Effects
  useEffect(() => {
    if (preset !== null && preset !== {} && preset !== undefined) {
      setElement((previousState) => {
        return { ...previousState, ...preset };
      });
    }
  }, [preset]);

  // Events
  const toggle = () => setModal(!modal);

  function onEdit() {
    setElement((previousState) => {
      previousState.properties.title = elementTitleRef.current.value;
      return previousState;
    });
    toggle();
  }

  return (
    <div className="form-builder-element" data={JSON.stringify(element)}>
      <button
        className="btn btn-danger btn-circle btn-sm mr-2 btn-builder-right"
        onClick={onElementDelete}
      >
        <i className="fa fa-trash"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={toggle}
      >
        <i className="fa fa-asterisk"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={onMoveDown}
      >
        <i className="fa fa-chevron-down"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={onMoveUp}
      >
        <i className="fa fa-chevron-up"></i>
      </button>

      <h2>{element.properties.title}</h2>

      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Edit Heading Properties</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Title</label>
            <input
              ref={elementTitleRef}
              type="text"
              id="title"
              className="form-control"
              defaultValue={element.properties.title}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={onEdit}>
            Update
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default Heading;
